import {
  GET_ALL_LANGUAGES,
  SET_LOADING_ALL_LANGUAGES,
  ERROR_ALL_LANGUAGES,
} from "../types";
import axiosInstance from "../request";

export function getAllLanguage() {
  return async function(dispatch) {
    try {
      dispatch({ type: SET_LOADING_ALL_LANGUAGES });

      const res = await axiosInstance.get(
        '/manage/languages/',
        {
          params: {
            page_size: 200,
          },
        }
      );
      const dataRes = res.data;

      dispatch({
        type: GET_ALL_LANGUAGES,
        payload: dataRes.results,
      });
    } catch (e) {
      dispatch({
        type: ERROR_ALL_LANGUAGES,
        payload: e.response,
      });
    }
  };
}
